import { type ComponentProps, type ReactNode } from 'react'
import { CheckCircle, AlertCircle, AlertTriangle, Info } from 'lucide-react'
import { Alert as BasisAlert, AlertTitle, AlertDescription } from './basis/alert'

type AlertVariant = 'default' | 'destructive' | 'success' | 'warning' | 'info'

export interface AlertProps extends Omit<ComponentProps<typeof BasisAlert>, 'children'> {
  variant?: AlertVariant
  /** Override the auto-injected icon; pass `null` to render none. */
  icon?: ReactNode
  children?: ReactNode
}

const defaultIcons: Record<AlertVariant, typeof Info> = {
  default: Info,
  destructive: AlertCircle,
  success: CheckCircle,
  warning: AlertTriangle,
  info: Info,
}

export function Alert({ variant = 'default', icon, children, ...props }: AlertProps) {
  const Icon = defaultIcons[variant]
  return (
    <BasisAlert variant={variant} {...props}>
      {icon !== undefined ? icon : <Icon className="size-4" />}
      {children}
    </BasisAlert>
  )
}

export { AlertTitle, AlertDescription }
